import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { Action, countriesActions } from "./countries-store";
import { errorActions as errorActions } from "src/components/error-viewer/error-store";
import { CountryGet } from "./countries-types";
import { CountryService } from "src/backend/openapi/v1";

export function* getCountriesRequest() {
  try {
    const result: CountryGet[] = yield call(CountryService.getApiV1Countries);
    yield put(countriesActions.getCountriesSuccess(result));
  } catch (error) {
    yield put(errorActions.addError(error));
  }
}

export function* watchGetCountriesRequest() {
  yield takeEvery(Action.GetCountriesRequest, getCountriesRequest);
}

export function* watchGetCountriesCacheRequest() {
  yield takeEvery(Action.GetCountriesCacheRequest, getCountriesRequest);
}

export function* countriesSaga() {
  yield all([fork(watchGetCountriesRequest), fork(watchGetCountriesCacheRequest)]);
}
